import { render, staticRenderFns } from "./TopMessage.vue?vue&type=template&id=20c1e139&scoped=true&"
import script from "./TopMessage.vue?vue&type=script&lang=js&"
export * from "./TopMessage.vue?vue&type=script&lang=js&"
import style0 from "./TopMessage.vue?vue&type=style&index=0&id=20c1e139&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c1e139",
  null
  
)

export default component.exports